/* RESPONSIBLE TEAM: team-automation-foundations */
export const TEAMMATE_APP_URL = document.querySelector("meta[name='teammate_app_url']")?.content;
